import React from "react";
import { Navigate } from "react-router-dom";
import { useAuth } from "@/context/AuthContext";
import { toast } from "sonner";

export default function RoleRoute({ roles, children }) {
  const { user } = useAuth();
  if (user === null) return null;
  if (!user || !roles.includes(user.role)) {
    // fire toast once
    setTimeout(() => toast.error("You don't have access to that page"), 0);
    return <Navigate to="/" replace />;
  }
  return children;
}
